export function determineActualEsMpvID(
    esMpvID: string,
    isLogoTouchUpFeatureFlagEnabled: boolean
): string {
    // If the ES MPV ID is not one of the new logo product IDs, then the ES MPV ID is returned as-is.

    const isLogoProduct = esMpvID.toLowerCase() === 'prologotouchupandcompletion';

    // ES MPV ID is passed in for the new service product and sometimes for non-enrolled users. If
    // isLogoTouchUpEnabled is true, then the new product flow should be used and it's okay to use the new
    // product flow.

    if (!isLogoProduct || isLogoTouchUpFeatureFlagEnabled) {
        return esMpvID;
    }

    // If it's the old logo flow but with the new ES MPV ID, we need to override it.

    return '';
}

export function determineActualProductKey(
    esMpvID: string,
    productKey: string,
    isLogoTouchUpFeatureFlagEnabled: boolean
): string {
    // If the product key isn't the legacy logo touch-up product key, return it as-is. This is even
    // in the case where ES MPV ID is set and should otherwise be overridden. Developers should not
    // provide both the product key and ES MPV ID if they want it to be overridden.

    if (productKey && productKey.toLowerCase() !== 'logo-touch-up-&-completion-service') {
        return productKey;
    }

    // Even if the user is enrolled, they must provide an ES MPV ID to use the new product flow.
    // `isLogoTouchUpFeatureFlagEnabled` should only be true when the ES MPV ID exists, but we defensively check here.

    if (esMpvID && isLogoTouchUpFeatureFlagEnabled) {
        return '';
    } else if (!esMpvID && productKey) {
        return productKey;
    }

    // In this case, the ES MPV ID is set but the feature gate says not to handle using the new
    // product flow. As a result, we need to override back to the legacy product key.

    return esMpvID.toLowerCase() === 'prologotouchupandcompletion'
        ? 'logo-touch-up-&-completion-service'
        : '';
}
